import { isProduction } from "utils/Global"

export const call = async <T>(
  method: string,
  params: {} & any,
  customer: string = process.env.REACT_APP_API_CUSTOMER,
  username: string = process.env.REACT_APP_API_USERNAME,
  password: string = process.env.REACT_APP_API_PASSWORD
): Promise<T> => {
  const host = process.env.REACT_APP_API_HOST_PROD
  const application = process.env.REACT_APP_API_APPLICATION
  try {
    return fetch(
      `https://${host}/data/integration/${customer}/${application}/${method}?ouname=root&application=${application}&customer=${customer}&username=${username}&password=${password}&`,
      {
        method: "POST",
        mode: "cors",
        cache: "default",
        credentials: "omit",
        body: JSON.stringify(params),
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json() as Promise<T>
    })
  } catch (e) {
    throw new Error(`Error in call: ${e}`)
  }
}

export const callLeaflet = async <T>(
  method: string,
  eanCode: string
): Promise<T> => {
  const host = isProduction()
    ? process.env.REACT_APP_LEAFLET_API_HOST_PROD
    : process.env.REACT_APP_LEAFLET_API_HOST

  try {
    return fetch(
      `https://${host}/api/EANCodeAPI/GetEANCodeData?EANCode=${eanCode}`,
      {
        method: method,
        mode: "cors",
        // cache: "default",
        // credentials: "omit",
        headers: {
          "auth-api-key": process.env.REACT_APP_API_KEY_EAN,
        },
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json() as Promise<T>
    })
  } catch (e) {
    throw new Error(`Error in call: ${e}`)
  }
}

export enum APIMethods {
  TECDOC_GETCOUNTRIES = "getCountries",
  TECDOC_GETARTICLE = "getArticleDirectSearchAllNumbersWithState",
  TECDOC_GETBRANDDETAILS = "getAmBrandAddress",
  TECDOC_GETARTICLEDETAILS = "getDirectArticlesByIds6",
  TECDOC_ADDIPADDRESS = "addDynamicAddress",
  TECDOC_GETVEHICLELIST = "getArticleLinkedAllLinkingTarget3",
  TECDOC_GETVEHICLEDETAILSLIST = "getVehicleByIds4",
  TECDOC_GETVEHICLELISTIMMEDIATEATTRIBUTS = "getArticleLinkedAllLinkingTargetsByIds3",
}
